import { selectCategoriesMap } from "../../store/categories/category.selector";
import { useSelector } from "react-redux";
import { CategoriesContext } from "../../contexts/cattegories.context";
import { useContext, Fragment } from 'react';
import CategoryPreview from "../../components/category-preview/category-prieview.component";


const CategoriesPreview=()=>{
    const categoriesMap=useSelector(selectCategoriesMap)
    return (
        <Fragment>
            {
                Object.keys(categoriesMap).map(title=>{
                    const products=categoriesMap[title]
                    return <CategoryPreview ket={title} title={title} products={products} />
                })
            }
       
        </Fragment>
        
    )


}
export default CategoriesPreview;